import type { FaireProductEntity } from "../../entity_types/product";

export const p_3ytdnhptzb: FaireProductEntity = {
  token: "p_3ytdnhptzb",
  type: "product",
  name: "Texture Ocean Coastal \u00a0Notebook \u00a0",
  brandName: "Jessica Frasz Studio",
  imageUrl:
    "https://cdn.faire.com/fastly/7f8cd72271df90c4bf7f974dc6f439fb36fa9cd755d0cb8568868c13b93446bc.jpeg",
  priceDollars: 9,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/0490fe741add28b3b130b563332b7d803e30530d6360440e528a8c8ab83838fe.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
